import script from "./TopBar_setup.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopBar_setup.vue?vue&type=script&setup=true&lang=ts"

import "./TopBar_setup.vue?vue&type=style&index=0&id=0e76126a&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e76126a"]])

export default __exports__